function FacebookSection() {
   return (
    <section
      className="scrollbar-hover-container flex min-h-0 flex-col"
      aria-labelledby="home-facebook-heading"
    >
     
      <div className="hidden md:flex min-h-0 flex-1 flex-col overflow-hidden" >
        <iframe
          src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FPEACIofficial%2F&tabs=timeline&width=500&height=800&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId"
          width="100%"
          height="100%"
          style={{ border: 'none', overflow: 'hidden', minHeight: '720px' }}
          allowFullScreen={true}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          title="Facebook Page Plugin - PEACI Official"
        />
      </div>
      <div className="md:hidden flex min-h-0 flex-1 flex-col overflow-hidden" >
        <iframe
          src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FPEACIofficial%2F&tabs=timeline&height=800&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId"
          width="100%"
          height="100%"
          style={{ border: 'none', overflow: 'hidden', minHeight: '720px' }}
          allowFullScreen={true}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          title="Facebook Page Plugin - PEACI Official"
        />
      </div>
    </section>
  );
}

export default FacebookSection;
